<h3 class="ui primary header">
  Change Bank Account Details
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div class="info">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
      stroke="#202223"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <p>
    Please note: Any changes made here will be verified before it appears on
    your profile
  </p>
</div>

<esl-message-toast [(message)]="error"></esl-message-toast>
<esl-message-toast
  [(message)]="success"
  [messageType]="'success'"
></esl-message-toast>

<div class="content">
  <div
    class="ui basic vertical segment bank-details"
    [ngClass]="{ loading: banks == undefined }"
    style="padding: 0; padding-bottom: 8px"
  >
    <h3 class="ui primary header" style="margin-top: 0">
      Current Bank Details
    </h3>
    <div class="ui divider"></div>
    <div>
      <h2 class="ui sub header">BANK NAME</h2>
      <span>{{
        modal.context.account?.activeBankDetails.bankName ||
          dataToJSON(modal.context.account?.activeBankDetails).bankName
      }}</span>
    </div>
    <div>
      <h2 class="ui sub header">BANK ACCOUNT NUMBER</h2>
      <span>{{
        modal.context.account?.activeBankDetails.bankAccountNumber ||
          dataToJSON(modal.context.account?.activeBankDetails).bankAccountNumber
      }}</span>
    </div>
    <div>
      <h2 class="ui sub header">BANK ACCOUNT NAME</h2>
      <span>{{
        modal.context.account?.activeBankDetails.bankAccountName ||
          dataToJSON(modal.context.account?.activeBankDetails).bankAccountName
      }}</span>
    </div>
    <div *ngIf="modal.context.account.currencyShortName == 'DOLLAR'">
      <div
        *ngIf="
          modal.context.account?.activeBankDetails.routingNumber ||
          dataToJSON(modal.context.account?.activeBankDetails)?.routingNumber
        "
      >
        <h2 class="ui sub header">IBAN/ROUTING NUMBER</h2>
        <span>{{
          modal.context.account?.activeBankDetails.routingNumber ||
            dataToJSON(modal.context.account?.activeBankDetails).routingNumber
        }}</span>
      </div>
      <div
        *ngIf="
          modal.context.account?.activeBankDetails.sortCode ||
          dataToJSON(modal.context.account?.activeBankDetails)?.sortCode
        "
      >
        <h2 class="ui sub header">SWIFT OR SORT CODE</h2>
        <span>{{
          modal.context.account?.activeBankDetails.sortCode ||
            dataToJSON(modal.context.account?.activeBankDetails).sortCode
        }}</span>
      </div>
      <div
        *ngIf="
          modal.context.account?.activeBankDetails.intermediarySortCode ||
          dataToJSON(modal.context.account?.activeBankDetails)
            ?.intermediarySortCode
        "
      >
        <h2 class="ui sub header">INTERMEDIARY BANK SWIFT CODE</h2>
        <span>{{
          modal.context.account?.activeBankDetails.intermediarySortCode ||
            dataToJSON(modal.context.account?.activeBankDetails)
              .intermediarySortCode
        }}</span>
      </div>
      <div
        *ngIf="
          modal.context.account?.activeBankDetails.bankPhysicalAddress ||
          dataToJSON(modal.context.account?.activeBankDetails)
            ?.bankPhysicalAddress
        "
      >
        <h2 class="ui sub header">BANK PHYSICAL ADDRESS</h2>
        <span>{{
          modal.context.account?.activeBankDetails.bankPhysicalAddress ||
            dataToJSON(modal.context.account?.activeBankDetails)
              .bankPhysicalAddress
        }}</span>
      </div>
    </div>
    <h3 class="ui primary header">Enter New Bank Details</h3>
    <div class="ui divider"></div>
    <form class="ui form" #changeBankDetailsForm="ngForm">
      <div
        class="field"
        appMargin
        marginB="15px"
        *ngIf="modal.context.account.currencyShortName == 'DOLLAR'"
      >
        <label>Beneficiary Name<span class="required-text">*</span></label>
        <div class="ui fluid input">
          <input
            type="text"
            placeholder="Enter beneficiary name"
            [(ngModel)]="accountName"
            name="account-name"
            required
          />
        </div>
      </div>

      <div class="field" appMargin marginB="15px">
        <label
          >{{
            modal.context.account.currencyShortName == "DOLLAR"
              ? "Banking Institution"
              : "Bank"
          }}<span class="required-text">*</span></label
        >
        <div class="ui fluid input">
          <sui-select
            class="fluid selection"
            placeholder="Select Bank"
            [options]="banks"
            [isSearchable]="true"
            labelField="optionName"
            [(ngModel)]="selectedBank"
            #select
            [required]="true"
            name="selected-bank"
            *ngIf="modal.context.account.currencyShortName != 'DOLLAR'"
          >
            <sui-select-option
              *ngFor="let option of select.filteredOptions"
              [value]="option"
            >
            </sui-select-option>
          </sui-select>
          <input
            type="text"
            *ngIf="modal.context.account.currencyShortName == 'DOLLAR'"
            placeholder="Enter banking institution"
            required
            name="selected-bank"
            [(ngModel)]="selectedBank"
          />
        </div>
      </div>

      <div
        class="field"
        appMargin
        marginB="15px"
        *ngIf="modal.context.account.currencyShortName != 'DOLLAR'"
      >
        <label>Account Name <span class="required-text">*</span></label>
        <div class="ui fluid input">
          <input
            type="text"
            placeholder="Enter account name"
            [(ngModel)]="accountName"
            name="account-name"
            required
          />
        </div>
      </div>

      <div class="field" appMargin marginB="15px">
        <label>Account Number<span class="required-text">*</span></label>
        <div class="ui fluid input">
          <input
            type="text"
            pattern="^[0-9]*$"
            inputmode="numeric"
            placeholder="Enter account number"
            [(ngModel)]="accountNumber"
            name="account-number"
            required
          />
        </div>
      </div>
      <div
        class="field"
        appMargin
        marginB="15px"
        *ngIf="modal.context.account.currencyShortName == 'DOLLAR'"
      >
        <label>Currency<span class="required-text">*</span> </label>
        <span class="currency-symbol"
          >{{ modal.context.account.currencyCode }}
        </span>
        <span class="currency-name">US Dollar</span>
      </div>
      <div
        class="field"
        appMargin
        marginB="15px"
        *ngIf="modal.context.account.currencyShortName == 'DOLLAR'"
      >
        <label
          >IBAN/Routing Number (Minimum of 5 digits and maximum of 12
          digit)</label
        >
        <div class="ui fluid input">
          <input
            type="text"
            pattern="^[0-9]*$"
            inputmode="numeric"
            placeholder="Enter IBAN"
            [(ngModel)]="ibanNumber"
            name="iban-number"
          />
        </div>
      </div>

      <div
        class="field"
        appMargin
        marginB="15px"
        *ngIf="modal.context.account.currencyShortName == 'DOLLAR'"
      >
        <label>SWIFT or Sort Code (e.g 12-34-56)</label>
        <div class="ui fluid input">
          <input
            type="text"
            pattern="[0-9]{2}-[0-9]{2}-[0-9]{2}"
            placeholder="Enter swift code"
            [(ngModel)]="sortCode"
            name="sort-code"
          />
        </div>
      </div>

      <div
        class="field"
        appMargin
        marginB="15px"
        *ngIf="modal.context.account.currencyShortName == 'DOLLAR'"
      >
        <label>Intermediary Bank SWIFT Code (e.g 12-34-56)</label>
        <div class="ui fluid input">
          <input
            type="text"
            pattern="[0-9]{2}-[0-9]{2}-[0-9]{2}"
            placeholder="Enter intermediary bank swift code"
            [(ngModel)]="intermediaryBankSwiftCode"
            name="international-bank-swift-code"
          />
        </div>
      </div>

      <div
        class="field"
        appMargin
        marginB="15px"
        style="padding-bottom: 8px"
        *ngIf="modal.context.account.currencyShortName == 'DOLLAR'"
      >
        <label>Bank Physical Address </label>
        <div class="ui fluid input">
          <input
            type="text"
            placeholder="Enter bank address"
            [(ngModel)]="bankAddress"
            name="bank-address"
          />
        </div>
      </div>
    </form>
  </div>

  <div class="actions" style="background: transparent; border: none">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Back
    </button>
    <button
      class="ui primary button"
      (click)="submit(); changeBankDetailsForm.reset()"
      [disabled]="!changeBankDetailsForm.form.valid || pending"
      [ngClass]="{ loading: pending }"
      autofocus
    >
      Save
    </button>
  </div>
</div>
